module.exports = __webpack_public_path__ + "img/tab-check-group.7d3857ce.svg";